module.exports = __webpack_public_path__ + "img/chevron_gris.b43f1e98.svg";